<template>
  <v-card class="ma-10">
    <!-- <v-sheet class="ma-2" color=""> -->
    <v-row class="ma-2">
      <!-- title col -->
      <v-col>
        <h1 class="font-weight-light display-2 text-uppercase">Depot Out</h1>
      </v-col>
    </v-row>
    <v-row
      wrap
      no-gutters
      justify="space-between"
      class="d-flex justify-center"
    >
      <v-col class="pa-2 d-flex">
        <v-card
          tile
          color="teal lighten-4"
          class="d-flex pa-2 flex-grow-1 rounded"
        >
          <v-row
            wrap
            no-gutters
            align="center"
            align-content="center"
            justify="space-between"
            class="flex-grow-1"
          >
            <v-col
              class="d-flex mr-2 flex-grow-1"
              justify="space-between"
              align-self="stretch"
              style="flex-direction: column"
            >
              <v-container
                class="mb-1 flex-grow-1 fill-height fluid align-items-center"
              >
                <v-row justify="center" align="center">
                  <!-- <v-spacer/> -->
                  <v-col cols="1">
                    <v-icon class="mx-2"> fa-hands-helping </v-icon>
                  </v-col>
                  <v-col cols="" class="mx-6">
                    <v-autocomplete
                      label="Organization?"
                      placeholder=""
                      :items="orgs"
                      item-text="org_name"
                      item-value="ID"
                      v-model="clientInfo['clientOrg']"
                      validate-on-blur
                      :rules="rules.notEmpty"
                    >
                    </v-autocomplete>
                  </v-col>
                </v-row>
              </v-container>

              <v-container class="mt-1 flex-grow-1 fill-height fluid">
                <v-row>
                  <v-col cols="1">
                    <v-icon class="mt-6 mx-2"> fa-user </v-icon>
                  </v-col>

                  <v-col cols="" class="mx-6">
                    <v-autocomplete
                      label="Username?"
                      placeholder=""
                      :items="orgUsers"
                      item-text="user_name"
                      item-value="ID"
                      v-model="clientInfo['clientID']"
                      validate-on-blur
                      :rules="rules.notEmpty"
                    >
                    </v-autocomplete>
                  </v-col>
                </v-row>
              </v-container>
            </v-col>
            <!-- </v-col> -->
            <!-- </v-col> -->

            <v-divider
              color="white"
              class="flex-grow-1 d-none d-md-block"
              vertical
            />

            <v-col
              class="d-flex ml-2 flex-grow-1"
              justify="space-between"
              align-self="stretch"
              style="flex-direction: column"
            >
              <v-container class="flex-grow-1 fill-height fluid">
                <v-list
                  flat
                  dense
                  style="background-color: rgba(85, 85, 85, 0)"
                >
                  <v-list-item v-for="(item, i) in infoItems" :key="i">
                    <v-list-item-icon class="small">
                      <v-icon v-text="item.icon"></v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <body-2 v-if="currClient">{{
                        currClient[item.value]
                      }}</body-2>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-container>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
      <!-- right box -->
      <v-col class="pa-2 d-flex">
        <v-card
          tile
          color="teal lighten-4"
          class="d-flex pa-2 flex-grow-1 rounded"
        >
          <v-row wrap no-gutters class="flex-grow-1">
            <!-- <v-col class="d-flex justify-center"> -->
            <v-col
              class="d-flex flex-grow-1 justify-space-between"
              style="flex-direction: column"
            >
              <v-container class="mb-auto pa-0">
                <v-list
                  flat
                  dense
                  style="background-color: rgba(85, 85, 85, 0)"
                >
                  <v-list-item dense>
                    <v-list-item-icon class="small">
                      <v-icon>fa-shopping-cart</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <h2>Totals</h2>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
                <v-divider />
              </v-container>
              <v-container class="px-12 pb-14">
                <v-row class="d-flex">
                  <v-icon class="pr-4 mb-auto">fa-weight-hanging</v-icon>
                  <span class="title font-weight-light">Weight</span>
                  <v-spacer />
                  <span class="title font-weight-light">
                    {{ totals.weight }} Kg</span
                  >
                </v-row>
                <v-row class="d-flex pt-4">
                  <v-icon class="pr-4 mb-auto">fa-boxes</v-icon>
                  <span class="title font-weight-light">Quantity</span>
                  <v-spacer />
                  <span class="title font-weight-light">
                    {{ totals.quantity }} Pieces</span
                  >
                </v-row>
              </v-container>
            </v-col>
            <!-- </v-col> -->
            <!-- </v-col> -->

            <v-divider class="flex-grow-1" vertical />

            <v-col
              class="d-flex flex-grow-1 justify-end"
              style="flex-direction: column"
            >
              <v-container class="px-8">
                <v-row class="d-flex">
                  <span class="title font-weight-light">Old Balance</span>
                  <v-spacer />
                  <span v-if="currClient" class="title font-weight-light">
                    {{ currClient["funds_balance"] }} Limbos</span
                  >
                </v-row>
              </v-container>
              <!-- <v-sheet height="50" color="red"> </v-sheet> -->
              <v-container class="px-8 mb-2">
                <v-row class="d-flex">
                  <span class="title font-weight-light">Total Price</span>
                  <v-spacer />
                  <span
                    v-if="totals.price > 0"
                    class="title font-weight-light red--text"
                  >
                    - {{ totals.price }} Limbos</span
                  >
                  <span
                    v-else-if="totals.price <= 0"
                    class="title font-weight-light green--text"
                  >
                    + {{ totals.price }} Limbos</span
                  >
                </v-row>
              </v-container>
              <v-divider />

              <v-container class="px-8 mt-2">
                <v-row class="d-flex">
                  <span class="title font-weight-light">New Balance</span>
                  <v-spacer />
                  <span v-if="currClient" class="title font-weight-light">
                    {{ currClient["funds_balance"] - totals.price }}
                    Limbos</span
                  >
                </v-row>
              </v-container>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="pr-7 d-flex justify-end">
        <v-btn
          outlined
          depressed
          large
          color="error"
          class="mr-2"
          @click="resetCart()"
        >
          Cancel
        </v-btn>
        <v-btn
          outlined
          depressed
          large
          color="success"
          @click="depotSell(itemsInCart, clientInfo.clientID)"
        >
          Out Depot
        </v-btn>
      </v-col>
    </v-row>
    <!-- </v-card> -->

    <v-spacer />

    <v-container fluid>
      <div
        class="
          table-header-prepend
          d-flex
          pl-2
          mb-4
          mr-4
          align-right
          justify-end
        "
      >
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              outlined
              color="primary"
              class="mr-3"
              v-on="on"
              @click="addRow()"
            >
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </template>
          <span>Add Item</span>
        </v-tooltip>
      </div>
      <!-- feedback on sale -->
      <div v-if="transactShow">
        <v-overlay z-index="1">
          <v-alert
            v-if="transactSuccess === 1"
            min-width="150"
            v-model="transactShow"
            dismissible
            elevation="24"
            z-index="2"
            prominent
            type="success"
            >Sold!</v-alert
          >
          <v-alert
            v-else-if="transactSuccess === 0"
            min-width="150"
            v-model="transactShow"
            dismissible
            elevation="24"
            z-index="2"
            prominent
            type="error"
            >Something went wrong!</v-alert
          >
        </v-overlay>
      </div>
      <!-- shopping cart-->
      <v-data-table
        :headers="headers"
        :items="itemsInCart"
        :items-per-page="-1"
        class="elevation-1"
        hide-default-footer
      >
        <template v-slot:body="{ items, headers }">
          <tbody>
            <tr v-for="item in items" :key="item.ID">
              <td v-for="(header, key) in headers" :key="key">
                <!-- show edit dialog for text-editable fields -->

                <v-text-field
                  v-if="header.readonly === true"
                  v-model="item[header.value]"
                  readonly
                  flat
                  single-line
                ></v-text-field>

                <v-text-field
                  v-if="
                    (header.value === 'kg' || header.value === 'pc') &&
                    item.Unit === header.value
                  "
                  type="number"
                  step="any"
                  min="0"
                  :max="item.maxAvailable"
                  @input="computeValues(item)"
                  v-model="item[header.value]"
                  validate-on-blur
                  :rules="rules.biggerThanZero"
                  rounded
                  background-color="teal lighten-4"
                ></v-text-field>

                <v-text-field
                  v-else-if="
                    (header.value === 'kg' || header.value === 'pc') &&
                    item.Unit !== header.value
                  "
                  type="number"
                  step="any"
                  min="0"
                  @input="computeValues(item)"
                  v-model="item[header.value]"
                  validate-on-blur
                  :rules="rules.biggerThanZero"
                  rounded
                  background-color="teal lighten-4"
                ></v-text-field>
                <v-autocomplete
                  v-if="header.value === 'IDCategory'"
                  v-model="item[header.value]"
                  @input="
                    updateCatSelections(
                      item[header.value],
                      item.ID,
                      'main',
                      'none'
                    )
                  "
                  rounded
                  background-color="teal lighten-4"
                  :items="availableCats"
                  item-text="text"
                  item-value="key"
                  validate-on-blur
                  :rules="rules.notEmpty"
                >
                  {{ item[header.value] }}
                </v-autocomplete>

                <v-autocomplete
                  v-else-if="header.value === 'IDSubCategory'"
                  v-model="item[header.value]"
                  @input="
                    updateCatSelections(
                      item.IDCategory,
                      item.ID,
                      'sub',
                      item[header.value]
                    )
                  "
                  rounded
                  background-color="teal lighten-4"
                  :items="item.subCatOptions"
                  item-text="text"
                  item-value="key"
                  validate-on-blur
                  :rules="rules.notEmpty"
                >
                  {{ item[header.value] }}
                </v-autocomplete>
              </td>

              <td>
                <v-btn class="mx-2" fab color="red" @click="removeRow(item.ID)">
                  <v-icon dark> fa-trash </v-icon>
                </v-btn>
              </td>
            </tr>
          </tbody>
        </template>
      </v-data-table>
      <v-alert type="error" :value="alert">
        Taking more than available! Please check available units!
      </v-alert>
      <!-- add the "addrow" button -->
    </v-container>
    <v-spacer />
    <!-- </v-sheet> -->
  </v-card>
</template>
<style>
.sticky-tab: {
  position: -webkit-sticky;
  position: sticky;
}
</style>

<script>
export default {
  computed: {
    totals: function () {
      // var tots = {};
      let totWeight = this.itemsInCart.reduce(function (
        accumulator,
        currentValue
      ) {
        return accumulator + parseFloat(currentValue.kg || 0);
      },
      0);
      let totPc = this.itemsInCart.reduce(function (accumulator, currentValue) {
        return accumulator + parseFloat(currentValue.pc || 0);
      }, 0);
      let totPrice = this.itemsInCart.reduce(function (
        accumulator,
        currentValue
      ) {
        return accumulator + parseFloat(currentValue.Price || 0);
      },
      0);
      var totals = { weight: totWeight, quantity: totPc, price: totPrice };
      console.log(totals);

      return totals;
    },
    orgUsers: function () {
      var result = this.users.filter((obj) => {
        return obj.org_ID === this.clientInfo.clientOrg;
      });
      return result;
    },
    currClient: function () {
      var currClient = this.users.filter((obj) => {
        return obj.ID === this.clientInfo.clientID;
      })[0];

      return currClient;
    },
    catchoices: function () {
      var choices = Object.keys(this.catObjs);
      return choices;
    },
    availableCats: function () {
      var avail = this.depotStock.map((item) => item.catName);

      avail = [
        ...new Set(
          this.depotStock.map((item) => {
            let properties = {
              key: item.catName,
              label: "blablabla",
              text: this.catTranslations.categories[item.catName][
                this.userLang
              ],
            };
            return properties;
          })
        ),
      ];

      return avail;
    },
  },

  methods: {
    fetchTranslations: function () {
      this.$api
        .get(this.$store.state.pathDepth + "lang/categories.json")
        .then((response) => {
          //   // console.log(response);
          this.catTranslations = response.data;
        });
    },
    getCookie: function (name) {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) return parts.pop().split(";").shift();
    },
    addRow: function () {
      // add appropriate ID's to each row
      var newItem = {
        ID: this.itemID,
        IDCategory: "",
        catOptions: [],
        subCatOptions: [],
        IDSubCategory: "",
        Unit: "",
        pricePunit: "",
        kg: "",
        Price: "",
        pc: "",
        dbPoids: "",
      };
      this.itemID++;

      this.itemsInCart.push(newItem);
    },
    removeRow: function (idx) {
      this.itemsInCart = this.itemsInCart.filter((item) => item.ID != idx);
    },
    depotSell: function (cart, user) {
      var vm = this;
      // console.log(this.show)
      cart = cart.filter((item) => item.depotID);
      // console.log(test);
      // console.log(user);
      if (this.alert == false) {
        this.$api
          .post(this.$store.state.pathDepth + "depot_sell.php", {
            user: user,
            cart: cart,
          })
          .then((response) => {
            // console.log(response.data);
            if (response.data === 1) {
              // console.log(response.data);
              vm.transactShow = true;
              vm.transactSuccess = 1;
              this.resetCart();
            } else {
              vm.transactSuccess = 0;
              vm.transactShow = true;
            }
          });
      }
    },
    fetchAll: function () {
      this.$api
        .post(this.$store.state.pathDepth + "sessions_check.php", {})
        .then((response) => {
          this.session = response.data;
          // console.log(this.session);
          this.$api
            .post(this.$store.state.pathDepth + "user_query.php", this.session)
            .then((response) => {
              this.users = response.data;
            });
        });
    },
    fetchOrgs: function () {
      this.$api
        .post(this.$store.state.pathDepth + "sessions_check.php", {})
        .then((response) => {
          this.session = response.data;
          this.$api
            .post(this.$store.state.pathDepth + "org_query.php", this.session)
            .then((response) => {
              this.orgs = response.data;
            });
        });
    },
    fetchDepotStock: function () {
      this.$api
        .post(this.$store.state.pathDepth + "sessions_check.php", {})
        .then((response) => {
          this.session = response.data;
          this.$api
            .post(this.$store.state.pathDepth + "depot_query.php", this.session)
            .then((response) => {
              this.depotStock = response.data;
            });
        });
    },
    initSubcats: function () {
      // set up the available subCats
      Object.keys(this.catObjs).forEach((key) => {
        this.subKeys.push(Object.keys(this.catObjs[key]));
      });
      this.subKeys = this.subKeys.flat();
    },
    updateCatSelections: function (catName, itemID, type, subCatName) {
      // populate subcategory options based on main cat selection AND other items
      var currItem = this.itemsInCart.filter((item) => item.ID == itemID)[0];
      if (type === "main") {
        // get the available subcatoptions
        let subcatsInCart = this.itemsInCart.map(
          (value) => value.IDSubCategory
        );
        console.log(subcatsInCart);
        // assign to item
        currItem.subCatOptions = this.depotStock
          .filter((n) => n.catName === catName)
          // .map((item) => item.subCatName)
          .map((item) => {
            let subCats = {
              key: item.subCatName,
              text: this.catTranslations.subcategories[catName][
                item.subCatName
              ][this.userLang],
            };
            return subCats;
          })
          .filter((item) => !subcatsInCart.includes(item.key));
        console.log(currItem.subCatOptions);

        // currItem.subCatOptions = currItem.subCatOptions.filter( ( el ) => !permittedValues.includes( el ) );
        //  !!!!! ADD RESET ALL VALUES TO EMPTY IF SELECTION IS MADE
      } else if (type === "sub") {
        var depotItem = this.depotStock.filter(
          (n) => n.catName === catName && n.subCatName === subCatName
        )[0];

        // set the appropriate item info

        currItem.depotID = depotItem.ID;
        currItem.Unit = depotItem.unit;
        if (currItem.Unit === "pc") {
          currItem.maxAvailable = depotItem.pieces - depotItem.total_items_sold;
        } else if (currItem.Unit === "kg") {
          currItem.maxAvailable = depotItem.depot_totalweight;
        }

        currItem.pricePunit = depotItem.price;
        currItem.pc = "0";
        currItem.kg = "0";
        currItem.dbPoids = depotItem.poids;
      }
      return name;
      // if the type is main
      // grab all the  matching subcats from the d epotstock
      // assign to item _options
      //
      // if the type is sub
    },
    computeValues: function (item) {
      console.log("compute");
      console.log(parseInt(item.kg));
      console.log(parseInt(item.maxAvailable));

      if (
        (item.Unit === "pc" &&
          parseInt(item.pc) > parseInt(item.maxAvailable)) ||
        (item.Unit === "kg" && parseInt(item.kg) > parseInt(item.maxAvailable))
      ) {
        this.alert = true;
      } else {
        this.alert = false;
      }

      //  compute price
      // if by weight
      if (item.Unit === "pc") {
        item.Price = parseFloat(item.pricePunit) * parseFloat(item.pc);
      } else if (item.Unit === "kg") {
        item.Price = parseFloat(item.pricePunit) * parseFloat(item.kg);
      }
      // if by unit
    },
    resetCart: function () {
      this.itemsInCart = [];
      this.clientInfo = {};
      this.userLang = this.getCookie("recup_lang");
      this.fetchTranslations();
      this.fetchAll();
      this.fetchOrgs();
      this.fetchDepotStock();
      this.initSubcats();
      // create a starter basket
      this.itemID = 0;
      for (var i = 0; i < 5; i++) {
        this.addRow(i);
      }
    },
  },
  created: function () {
    this.resetCart();
  },

  data() {
    return {
      rules: {
        notEmpty: [(v) => !!v || "Can't be empty!"],
        biggerThanZero: [(v) => v > 0 || "Needs more than 0!"],
      },
      transactShow: false,
      transactSuccess: "",
      alert: false,
      selectedItem: 1,
      catObjs: {
        wood: { osb: {}, massif: {} },
        metal: { alu: {}, iron: {} },
      },
      subKeys: [],
      itemID: 0,
      infoItems: [
        { text: "Partner", icon: "mdi-clock" },
        { text: "", icon: "fa-coins", value: "funds_balance" },
        { text: "", icon: "fa-phone", value: "phone" },
        { text: "", icon: "fa-envelope", value: "user_email" },
      ],
      items: [
        { text: "Real-Time", icon: "mdi-clock" },
        { text: "Audience", icon: "mdi-account" },
        { text: "Conversions", icon: "mdi-flag" },
      ],
      headers: [
        {
          text: "Category",
          value: "IDCategory",
          type: "select",
          readonly: false,
        },
        {
          text: "Sub Category",
          value: "IDSubCategory",
          type: "select",
          readonly: false,
        },
        {
          text: "Total Weight",
          value: "kg",
          type: "number",
          readonly: false,
        },
        {
          text: "Quantity",
          value: "pc",
          type: "number",
          readonly: false,
        },

        {
          text: "Amount in Stock",
          value: "maxAvailable",
          type: "select",
          readonly: true,
        },
        { text: "Unit", value: "Unit", type: "text", readonly: true },
        {
          text: "Price/Unit",
          value: "pricePunit",
          type: "text",
          readonly: true,
        },
        { text: "Total Price", value: "Price", type: "text", readonly: true },
      ],
      itemRowDefault: {
        ID: " ",
        IDCategory: " ",
        IDSubCategory: " ",
        Unit: " ",
        pricePunit: " ",
        kg: "0",
        Price: " ",
        pc: "0",
        dbPoids: "",
      },
      itemsInCart: [],
      users: [],
      clientInfo: {},
      orgs: [],
      depotStock: [],
    };
  },
};
</script>
